import { ForgotPasswordEmailViewModel } from '@apis/model';
import { toCaptchaViewModel } from '@apis/responseTransformer/toCaptchaViewModel';
import { ForgotPasswordEmailResponse } from '@ul/api';

export const toForgotPasswordEmailViewModel = (
    forgotPasswordResponse: ForgotPasswordEmailResponse
): ForgotPasswordEmailViewModel => {
    const { success, responseCode } = forgotPasswordResponse;
    return {
        responseCode,
        success,
        captchaViewModel: toCaptchaViewModel(forgotPasswordResponse),
    };
};
